// Inventory status + action visual metadata
export const STATUS_META = {
  STOCK_OUT: { label: "Stock Out", dot: "bg-red-600", badge: "bg-red-50 text-red-700 border-red-200", accent: "#dc2626" },
  CRITICAL: { label: "Critical", dot: "bg-rose-500", badge: "bg-rose-50 text-rose-700 border-rose-200", accent: "#e11d48" },
  POTENTIAL_STOCKOUT: { label: "Potential Stockout", dot: "bg-amber-500", badge: "bg-amber-50 text-amber-700 border-amber-200", accent: "#d97706" },
  REORDER: { label: "Reorder Required", dot: "bg-blue-500", badge: "bg-blue-50 text-blue-700 border-blue-200", accent: "#2563eb" },
  ON_ORDER: { label: "On Order", dot: "bg-cyan-500", badge: "bg-cyan-50 text-cyan-700 border-cyan-200", accent: "#0891b2" },
  OVERSTOCKED: { label: "Overstocked", dot: "bg-violet-500", badge: "bg-violet-50 text-violet-700 border-violet-200", accent: "#7c3aed" },
  NON_MOVER: { label: "Non-Mover", dot: "bg-slate-400", badge: "bg-slate-100 text-slate-600 border-slate-200", accent: "#64748b" },
  HEALTHY: { label: "Healthy", dot: "bg-emerald-500", badge: "bg-emerald-50 text-emerald-700 border-emerald-200", accent: "#059669" },
};

export const statusMeta = (s) => STATUS_META[s] || { label: s || "–", dot: "bg-slate-300", badge: "bg-slate-100 text-slate-600 border-slate-200", accent: "#94a3b8" };

export const ACTION_META = {
  "PLACE PO": "bg-red-600 text-white",
  "EXPEDITE EXISTING PO": "bg-amber-500 text-white",
  "REVIEW OVERSTOCK": "bg-violet-600 text-white",
  "REVIEW NON-MOVER": "bg-slate-500 text-white",
  "REVIEW LEAD TIME": "bg-blue-600 text-white",
  MONITOR: "bg-slate-200 text-slate-700",
  "NO ACTION": "bg-slate-100 text-slate-500",
};
export const actionClass = (a) => ACTION_META[a] || "bg-slate-100 text-slate-500";
